export const API_ROUTES = {
    // Auth related routes
    AUTH: {
        LOGIN: '/user/login',
        REGISTER: '/user/register',
        LOGOUT: '/user/logout',
        CHANGE_PASSWORD: '/user/change_password',
        SEND_RESET_PASSWORD_LINK: '/user/send_reset_link',
        RESET_PASSWORD: '/user/reset_password',
        MAGIC_LOGIN: '/user/magic_login',
    },

    // Tender related routes
    TENDERS: {
        BASE: '/tenders',
        DETAIL: (uuid) => `/tenders/${uuid}`,
        DOCUMENT: (uuid) => `/private/tenders/${uuid}/document`,
        BY_KEYWORDS: '/tenders/keywords',
        BY_CATEGORY: '/tenders/category',
        BY_COUNTRY: '/tenders/country',
        BY_REGION: '/tenders/region',
        BY_POLITICAL_REGION: '/tenders/political-region',
        BY_GEO_REGION: '/tenders/geo-region',
        FUNDING_AGENCIES: '/tenders/funding-agencies',
        LIVE: '/tenders/live',
        PRIVATE: '/private/tenders',
        FAVOURITE_TENDER: '/private/favourite-tender',
        FAVOURITE_TENDERS: '/private/favourite-tenders',
        PRIVATE_DETAIL: (uuid) => `/private/tenders/${uuid}`,
        SEARCH: '/tenders/search',
        CSV_TENDERS: '/private/tender-export',
        ANALYTICS: '/private/analytics',
        EMAILALERTTENDERS: (queryId) => `/private/email_alert/${queryId}/tenders`,
    },

    // Contract related routes
    CONTRACTS: {
        BASE: '/contracts',
        DETAIL: (uuid) => `/contracts/${uuid}`,
        PRIVATE: 'private/contracts',
        PRIVATE_DETAIL: (uuid) => `/private/contracts/${uuid}`,
        SEARCH: '/contracts/search'
    },

    // User related routes
    USER: {
        PROFILE: '/user/profile',
        UPDATE_PROFILE: '/user/profile/update',
        QUERIES: '/query',
        QUERY_DETAIL: (id) => '/user/queries/${id}',
        UPDATE_QUERY: (id) => '/user/queries/${id}/update',
        DELETE_QUERY: (id) => '/user/queries/${id}/delete',
        SUBSCRIPTION: '/user/subscription',
        NOTIFICATIONS: '/user/notifications',
        CREATE_LEAD: '/lead',
        GET_LEAD: (uuid) => `/lead/${uuid}`,
    },

    // Dashboard related routes
    DASHBOARD: {
        // STATS: '/dashboard/stats',
        STATS: '/private/counts',
        RECENT_TENDERS: '/dashboard/recent-tenders',
        RECENT_CONTRACTS: '/dashboard/recent-contracts',
        SAVED_SEARCHES: '/dashboard/saved-searches',
        EMAIL_ALERTS: '/private/email-alerts',
    },

    // Subscription related routes
    SUBSCRIPTION: {
        PLANS: '/subscription-plans',
        SUBSCRIBE: '/subscription/subscribe',
        CANCEL: '/subscription/cancel',
        UPGRADE: '/subscription/upgrade'
    },

    BLOG: {
        BASE: '/blog',
        DETAIL: (uuid) => `/blog/${uuid}`,
    },

    // Region related routes
    MDATA: {
        METADATA: '/mdata'
    },

    PAYMENT: {
        INITIATE: '/payment/initiate',
        VERIFY: '/payment/verify',
        HISTORY: '/payment/history'
    }
}; 